export enum SentStatus {
  NOT_SENT,
  SENT,
  RECEIVED,
  VIEWED,
}
